export enum PageToolTypeEnum {
  INSTANT_VALUATION_TOOL = "ivt",
  FORM = "form",
  QUESTIONNAIRE = "questionnaire",
}
